import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SUPPORT_PAGE_PATH } from '@/constants/routes';

export default function CrispManager() {
  const location = useLocation();

  useEffect(() => {
    window.$crisp.push([
      'on',
      'chat:closed',
      () => {
        const path = window.location.pathname;
        const isVisiblePage = path === '/' || path.startsWith(SUPPORT_PAGE_PATH);
        if (!isVisiblePage) {
          window.$crisp.push(['do', 'chat:hide']);
        }
      }
    ]);
  }, []);

  useEffect(() => {
    const isHome = location.pathname === '/';

    const interval = setInterval(() => {
      const crispFrame = document.querySelector<HTMLElement>('.crisp-client');

      if (crispFrame) {
        if (isHome) {
          crispFrame.style.display = 'block';
        } else {
          crispFrame.style.display = 'none';
        }

        clearInterval(interval);
      }
    }, 300);

    return () => clearInterval(interval);
  }, [location.pathname]);

  return null;
}
